import moment from "moment";
import momentTz from "moment-timezone";

Object.defineProperty(Date.prototype, 'addYears', {
  value: function (yearNo) {
    return new Date((new Date(this)).setFullYear(this.getFullYear() + yearNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'addMonths', {
  value: function (monthNo) {
    return new Date((new Date(this)).setMonth(this.getMonth() + monthNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'addDays', {
  value: function (dayNo) {
    return new Date((new Date(this)).setDate(this.getDate() + dayNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'addHours', {
  value: function (hourNo) {
    return new Date((new Date(this)).setHours(this.getHours() + hourNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'addMinutes', {
  value: function (minuteNo) {
    return new Date((new Date(this)).setMinutes(this.getMinutes() + minuteNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'addSeconds', {
  value: function (secondNo) {
    return new Date((new Date(this)).setSeconds(this.getSeconds() + secondNo));
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'toUTC', {
  value: function () {
    return new Date(this.getTime() + this.getTimezoneOffset() * 60000);
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'startOfYear', {
  value: function () {
    return moment(this)
      .startOf("year")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'endOfYear', {
  value: function () {
    return moment(this)
      .endOf("year")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'startOfMonth', {
  value: function () {
    return moment(this)
      .startOf("month")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'endOfMonth', {
  value: function () {
    return moment(this)
      .endOf("month")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'startOfDay', {
  value: function () {
    return moment(this)
      .startOf("day")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'endOfDay', {
  value: function () {
    return moment(this)
      .endOf("day")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'startOfWeek', {
  value: function () {
    return moment(this)
      .startOf("week")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'endOfWeek', {
  value: function () {
    return moment(this)
      .endOf("week")._d;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'format', {
  value: function (format) {
    return moment(this).format(format);
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'setTiming', {
  value: function (hour, minute, second, millisecond) {
    if (typeof hour != "undefined")
      this.setHours(hour);
    if (typeof minute != "undefined")
      this.setMinutes(minute);
    if (typeof second != "undefined")
      this.setSeconds(second)
    if (typeof millisecond != "undefined")
      this.setMilliseconds(millisecond)
    return this;
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'toTimezone', {
  value: function (timezone, format) {
    return momentTz(this, format).tz(timezone).format(format);
    //return this.toLocaleString('en-US', { timeZone: timezone }).format(format);
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Date.prototype, 'setTimezone', {
  value: function (timezone) {
    return momentTz(this).tz(timezone)._d;
  },
  enumerable: false,
  writable: false
});
